export default __webpack_public_path__ + "assets/models/bdc5e77007ac121b570421e19198de0f.glb";